import { render, staticRenderFns } from "./multymediapage.vue?vue&type=template&id=03284abd"
import script from "./multymediapage.vue?vue&type=script&lang=js"
export * from "./multymediapage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports